/* Parent code display + clipboard copy dialog. Extracted from Students.js
 * (2026-02 refactor). Pure presentational — all state managed by parent. */
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Key, Copy, Check } from '@phosphor-icons/react';

export default function ParentCodeDialog({
  open, onOpenChange, parentCode, codeCopied, onCopy, language, t,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-outfit text-xl flex items-center gap-2">
            <Key size={24} className="text-[#10B981]" />
            {t('parentCode')}
          </DialogTitle>
        </DialogHeader>
        {parentCode && (
          <div className="space-y-4">
            <div className="text-center">
              <p className="font-manrope text-sm text-[#64748B] mb-2">
                {language === 'fr' ? 'Code pour' : 'Code for'}:{' '}
                <span className="font-medium text-[#0F172A]">{parentCode.student_name}</span>
              </p>
              <div className="flex items-center justify-center gap-2">
                <div className="px-6 py-4 bg-[#F1F5F9] rounded-lg">
                  <span className="font-mono text-2xl font-bold text-[#0F172A]">
                    {parentCode.parent_code}
                  </span>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={onCopy}
                  className={`border-[#E2E8F0] ${codeCopied ? 'bg-[#10B981] text-white border-[#10B981]' : ''}`}
                  data-testid="copy-code-btn"
                >
                  {codeCopied ? <Check size={18} /> : <Copy size={18} />}
                </Button>
              </div>
            </div>
            <p className="text-sm text-[#64748B] text-center font-manrope">
              {language === 'fr'
                ? 'Partagez ce code avec le parent pour qu\'il puisse créer son compte.'
                : 'Share this code with the parent so they can create their account.'}
            </p>
          </div>
        )}
        <DialogFooter>
          <Button
            onClick={() => onOpenChange(false)}
            className="bg-[#0052FF] hover:bg-[#0043D1]"
          >
            {t('confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
